<template>
  <div>
    <v-container>
        <v-data-table
            v-bind:headers="headers"
            :items="pois"
            hide-actions
            class="elevation-1"
            >
             <template slot="items" scope="props">
                <td>{{ props.item.description }}</td>
                <td>{{ props.item.lat }}</td>
                <td>{{ props.item.lng }}</td>
                <td  class="text-xs-right"><a @click="remove_poi(props.item)"><v-icon>delete_forever</v-icon></a></td>
            </template>pois
        </v-data-table>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'poi-overview',
  mounted() {
      this.$store.dispatch('RETRIEVE_POIS');
  },
  data() {
      return {
          headers: [
              {text: 'Omschrijving', align: 'left', sortable: false},
              {text: 'Latitude', align: 'left', sortable: false},
              {text: 'Latitude', align: 'left', sortable: false},
              {text: '', align: 'right', sortable: false},
          ]
      }
  },
  computed: {
      pois() {
          return this.$store.getters.pois;
      }
  },
  methods: {
      remove_poi(poi) {
          this.$store.dispatch('REMOVE_POI', poi);
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PoiOverview.vue